var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "order-return-edit-customer-details flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    Customer Details\n  "),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "edit-customer-details" }, [
        _c("div", { staticClass: "flex flex-col gap_s" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-row gap-16" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.editedCustomer.customerFirstName,
                  expression: "editedCustomer.customerFirstName",
                },
              ],
              staticClass: "flex-1 input-field",
              staticStyle: { height: "48px" },
              domProps: { value: _vm.editedCustomer.customerFirstName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.editedCustomer,
                    "customerFirstName",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.editedCustomer.customerLastName,
                  expression: "editedCustomer.customerLastName",
                },
              ],
              staticClass: "flex-1 input-field",
              staticStyle: { height: "48px" },
              domProps: { value: _vm.editedCustomer.customerLastName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.editedCustomer,
                    "customerLastName",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.errors.customerFirstName || _vm.errors.customerLastName
            ? _c("div", { staticClass: "flex flex-row gap-16" }, [
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.errors.customerFirstName) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.errors.customerLastName) +
                      "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row gap-16" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editedCustomer.customer_email,
                    expression: "editedCustomer.customer_email",
                  },
                ],
                staticClass: "flex-1 input-field",
                staticStyle: { height: "48px" },
                domProps: { value: _vm.editedCustomer.customer_email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.editedCustomer,
                      "customer_email",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "vue-tel-input",
                {
                  staticClass: "flex-1 input-field",
                  staticStyle: { height: "48px" },
                  attrs: {
                    "preferred-countries": ["US", "IN", "AR"],
                    mode: "international",
                  },
                  on: { validate: _vm.updatePhoneValidation },
                  model: {
                    value: _vm.editedCustomer.customer_phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.editedCustomer, "customer_phone", $$v)
                    },
                    expression: "editedCustomer.customer_phone",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-dialog__close el-icon el-icon-arrow-down",
                    attrs: { slot: "arrow-icon" },
                    slot: "arrow-icon",
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.errors.customer_email || _vm.errors.customer_phone
            ? _c("div", { staticClass: "flex flex-row gap-16" }, [
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.errors.customer_email) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.errors.customer_phone) +
                      "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "edit-customer-details" }, [
        _c("div", { staticClass: "flex flex-col gap_s" }, [
          _vm._m(4),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row gap-16" },
            [
              _c("el-input", {
                directives: [
                  {
                    name: "google-places",
                    rawName: "v-google-places",
                    value: _vm.googleOn,
                    expression: "googleOn",
                  },
                ],
                staticClass: "flex-1 input-field",
                staticStyle: { padding: "0px", height: "48px" },
                on: { selected: _vm.placeSelected },
                model: {
                  value: _vm.editedAddress.address_1,
                  callback: function ($$v) {
                    _vm.$set(_vm.editedAddress, "address_1", $$v)
                  },
                  expression: "editedAddress.address_1",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-row gap-16" }, [
            _vm.errors.address_1
              ? _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.address_1) + "\n        "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row gap-16" },
            [
              _c("el-input", {
                staticClass: "flex-1 input-field",
                staticStyle: { padding: "0px", height: "48px" },
                model: {
                  value: _vm.editedAddress.address_2,
                  callback: function ($$v) {
                    _vm.$set(_vm.editedAddress, "address_2", $$v)
                  },
                  expression: "editedAddress.address_2",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-row gap-16" }, [
            _vm.errors.address_2
              ? _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.address_2) + "\n        "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm._m(6),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row gap-16" },
            [
              _c("country-input", {
                staticClass: "flex-1 select-field",
                attrs: { value: _vm.country_code },
                on: { input: _vm.emptyState },
                model: {
                  value: _vm.country_code,
                  callback: function ($$v) {
                    _vm.country_code = $$v
                  },
                  expression: "country_code",
                },
              }),
              _vm._v(" "),
              _c("country-state-input", {
                staticClass: "flex-1 select-field",
                attrs: { "input-type": "select", country: _vm.country_code },
                model: {
                  value: _vm.state_code,
                  callback: function ($$v) {
                    _vm.state_code = $$v
                  },
                  expression: "state_code",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.errors.country || _vm.errors.state
            ? _c("div", { staticClass: "flex flex-row gap-16" }, [
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.country) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.state) + "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(7),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-row gap-16" },
            [
              _c("el-input", {
                staticClass: "flex-1 input-field",
                staticStyle: { padding: "0px", height: "48px" },
                model: {
                  value: _vm.editedAddress.city,
                  callback: function ($$v) {
                    _vm.$set(_vm.editedAddress, "city", $$v)
                  },
                  expression: "editedAddress.city",
                },
              }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "flex-1 input-field",
                staticStyle: { padding: "0px", height: "48px" },
                model: {
                  value: _vm.editedAddress.zip,
                  callback: function ($$v) {
                    _vm.$set(_vm.editedAddress, "zip", $$v)
                  },
                  expression: "editedAddress.zip",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.errors.city || _vm.errors.zip
            ? _c("div", { staticClass: "flex flex-row gap-16" }, [
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.city) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1 input-error" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errors.zip) + "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "24px" } }, [
      _c("div", { staticClass: "section-header" }, [
        _vm._v("\n      Customer details\n    "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          First Name\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Last Name\n        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Email\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Phone Number\n        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "16px" } }, [
      _c("div", { staticClass: "section-header" }, [
        _vm._v("\n      Address\n    "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Address Line 1\n        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Address Line 2\n        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Country\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          State\n        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-row gap-16" }, [
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          City\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-1 input-label" }, [
        _vm._v("\n          Zip code\n        "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }